import React from 'react';

export default function SlotButton({ children, disabled, onClick, className = '' }) {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`px-2 py-1 text-sm rounded border ${disabled ? 'text-gray-400 border-gray-200' : 'hover:bg-gray-50'} ${className}`}>
      {children}
    </button>
  );
}
